import React from 'react'
import store from '../../../redux/store'
import { BookingService } from 'banking/services'
import AgreementModal from '../components/agreement-modal/agreement-modal'
import { UNSAFE_renderElement as renderElement } from '@/hooks/useGlobalPortal'

const openAgreementModal = ({ handleConfirm, handleError, handleAbort }) => {
  const getComponent = ({ token, text, close }) => {
    return (
      <AgreementModal
        open
        token={token}
        text={text}
        store={store}
        handleConfirm={() => {
          close()
          handleConfirm()
        }}
        handleAbort={() => {
          close()
          handleAbort()
        }}
        handleError={handleError} />
    )
  }

  const startAgreementProcess = () => {
    BookingService.agreements.start()
      .then((result) => {
        const { body: { data: { authtoken, displayTextHtml } } } = result
        renderElement((close) => getComponent({ token: authtoken, text: displayTextHtml, close }))
      })
      .catch((e) => { console.error(e) })
  }

  BookingService.agreements.getMissing()
    .then((result) => {
      const { body: { data: { agreementsMissing } } } = result
      if (!agreementsMissing) return handleConfirm()

      startAgreementProcess()
    })
    .catch(e => console.error(e))

}

export default openAgreementModal
